module.exports = __webpack_public_path__ + "static/img/19ha.80a6f25f.gif";